import axios from "axios";
import { installFeedback } from "@/lib/feedback";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE });
installFeedback(api);

const TOKEN_KEY = "dpr_token";

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem(TOKEN_KEY);
  }
}

// The branch chosen in the top bar. Sent with every request, so lists show only that branch and new records join it.
export const BRANCH_KEY = "erp_selected_branch_id";

api.interceptors.request.use((config) => {
  const branch = localStorage.getItem(BRANCH_KEY);
  if (branch) config.headers["X-Branch-Id"] = branch;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      setAuthToken(null);
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
